angular.module('tf.models')

    .factory("BillingInvoice", [function () {

        var billingInvoice = function BillingInvoice(data) {
            this.loadData(data);
        };

        var currency_symbols = {
            'USD': '$', // US Dollar
            'EUR': '€', // Euro
            'CRC': '₡', // Costa Rican Colón
            'GBP': '£', // British Pound Sterling
            'ILS': '₪', // Israeli New Sheqel
            'INR': '₹', // Indian Rupee
            'JPY': '¥', // Japanese Yen
            'CNY': '¥', // Renminbi (Yuan)
            'KRW': '₩', // South Korean Won
            'NGN': '₦', // Nigerian Naira
            'PHP': '₱', // Philippine Peso
            'PLN': 'zł', // Polish Zloty
            'PYG': '₲', // Paraguayan Guarani
            'THB': '฿', // Thai Baht
            'UAH': '₴', // Ukrainian Hryvnia
            'VND': '₫', // Vietnamese Dong
        };


        billingInvoice.prototype = {
            loadData: function (data) {
                angular.extend(this, data);
            },
            getTotal: function () {
                //Total after discounts and taxes. in cents
                return this.total/100;
            },
            getLink: function () {
                return this.hosted_invoice_url;
            },
            getPdfLink: function () {
                return this.invoice_pdf;
            },
            getPDFLink: function () {
                return this.invoice_pdf;
            },
            isPaid: function () {
                return this.paid;
            },
            getNumber: function () {
                return this.number;
            },
            getData: function(){
                return _.first(this.lines.data);
            },
            getPeriod: function () {
                var data = this.getData();
                if(data.period && data.period.start && data.period.end) {
                    return {
                        start: new Date(this.getData().period.start * 1000).toISOString().split("T")[0],
                        end: new Date(this.getData().period.end * 1000).toISOString().split("T")[0]
                    };
                }else{
                    return {
                        start: '',
                        end : ''
                    };
                }
            },
            getQty: function (){
                var qty = 0;
                this.lines.data.forEach(function(line){
                    qty += line.quantity;
                });
                return qty;
            },
            amountDue: function (){
                //Final amount due at this time for this invoice, in cents
                return this.amount_due/100;
            },
            getItemPrice : function(){
                var singleRenderPrice = this.getData().plan.amount;
                //if this plan have tiers
                if(this.getData().plan.tiers){
                    singleRenderPrice = _.last(this.getData().plan.tiers).unit_amount;
                }
                //In cents
                return Number(singleRenderPrice)/100;
            },
            getCurrency: function(){
                if(currency_symbols[this.currency.toUpperCase()]!==undefined) {
                    return currency_symbols[this.currency.toUpperCase()];
                }else{
                    return this.currency;
                }
            }
        };

        return billingInvoice;

    }])
;
